import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Home from "./pages/Home";
import Initiatives from "./pages/Initiatives";
import Gallery from "./pages/Gallery";
import PublicInstitutionsStudy from "./pages/research/PublicInstitutionsStudy";

/** Scrolls to the top of the page on every route change (except hash links,
 *  which Home.jsx handles itself by scrolling to the target section). */
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/initiatives" element={<Initiatives />} />
        <Route path="/research/public-institutions" element={<PublicInstitutionsStudy />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}
